import * as React from "react";
import { logger } from "@origin-digital/reporting-client";

interface IState {
  error?: Error;
}

// Like the event horizon of a black hole, this is the point at which no error can escape its
// sheer gravitational pull.
// Errors can never leak out to be visible to those outside the void, but like Hawking radiation,
// we may infer their existence through error logs
export class ErrorBoundary extends React.Component<{}, IState> {
  state: IState = {};

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    logger.error("ErrorBoundary caught:", error);
  }

  render() {
    if (this.state.error) {
      return null;
    }

    return this.props.children;
  }
}

export const withErrorBoundary = (Component: React.ReactType) => {
  const WrappedComponent = (props) => (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );

  return WrappedComponent;
};
